module.exports = __webpack_public_path__ + "img/colete.f391ff86.svg";